// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { EraseTileOption, EraseTileOptionT } from '../tbs/erase-tile-option.js';
import { Position, PositionT } from '../tbs/position.js';


export class EraseTileAction implements flatbuffers.IUnpackableObject<EraseTileActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EraseTileAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEraseTileAction(bb:flatbuffers.ByteBuffer, obj?:EraseTileAction):EraseTileAction {
  return (obj || new EraseTileAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEraseTileAction(bb:flatbuffers.ByteBuffer, obj?:EraseTileAction):EraseTileAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EraseTileAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapEraseTile;
}

options(obj?:EraseTileOption):EraseTileOption|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new EraseTileOption()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

position(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startEraseTileAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapEraseTile);
}

static addOptions(builder:flatbuffers.Builder, optionsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, optionsOffset, 0);
}

static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, positionOffset, 0);
}

static endEraseTileAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): EraseTileActionT {
  return new EraseTileActionT(
    this.type(),
    (this.options() !== null ? this.options()!.unpack() : null),
    (this.position() !== null ? this.position()!.unpack() : null)
  );
}


unpackTo(_o: EraseTileActionT): void {
  _o.type = this.type();
  _o.options = (this.options() !== null ? this.options()!.unpack() : null);
  _o.position = (this.position() !== null ? this.position()!.unpack() : null);
}
}

export class EraseTileActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapEraseTile,
  public options: EraseTileOptionT|null = null,
  public position: PositionT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const options = (this.options !== null ? this.options!.pack(builder) : 0);
  const position = (this.position !== null ? this.position!.pack(builder) : 0);

  EraseTileAction.startEraseTileAction(builder);
  EraseTileAction.addType(builder, this.type);
  EraseTileAction.addOptions(builder, options);
  EraseTileAction.addPosition(builder, position);

  return EraseTileAction.endEraseTileAction(builder);
}
}
